import React, { useEffect, useState, useRef } from 'react';
import { RiCheckLine, RiErrorWarningLine, RiInformationLine, RiCloseLine } from 'react-icons/ri';
import './Toast.css';

const Toast = ({ id, message, type, onClose }) => {
  const [isExiting, setIsExiting] = useState(false);
  const toastRef = useRef(null);
  
  useEffect(() => {
    // Add a slight delay before starting the exit animation
    const timeout = setTimeout(() => {
      setIsExiting(true);
    }, 2700); // Start exit animation slightly before the toast is removed
    
    // Ensure the toast has the enter animation class initially
    if (toastRef.current) {
      toastRef.current.style.animation = 'toast-in 0.5s cubic-bezier(0.21, 1.02, 0.73, 1) forwards';
    }
    
    return () => clearTimeout(timeout);
  }, []);
  
  const handleClose = () => {
    setIsExiting(true);
    
    // Apply exit animation directly to ensure it runs
    if (toastRef.current) {
      toastRef.current.style.animation = 'toast-out 0.5s cubic-bezier(0.06, 0.71, 0.55, 1) forwards';
    }
    
    setTimeout(onClose, 500); // Wait for exit animation to complete
  };
  
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <RiCheckLine />;
      case 'error':
        return <RiErrorWarningLine />;
      case 'info':
        return <RiInformationLine />;
      default:
        return <RiInformationLine />;
    }
  };
  
  return (
    <div 
      ref={toastRef}
      className={`toast toast-${type} ${isExiting ? 'toast-exit' : 'toast-enter'}`}
    >
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-message">{message}</div>
      <button className="toast-close" onClick={handleClose}>
        <RiCloseLine />
      </button>
    </div>
  );
};

export default Toast;
